import Box from "@mui/material/Box";
import type { TextFieldProps } from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import HidenTextField from "./HidenTextField";

interface RegisterPasswordTextFieldType
  extends Omit<TextFieldProps, "helperText"> {
  minMaxError: boolean;
  lowercaseLetterError: boolean;
  uppercaseLetterError: boolean;
  digitsError: boolean;
  specialCharError: boolean;
  notViewHelperText?: boolean;
}

export default function RegisterPasswordTextField({
  minMaxError,
  lowercaseLetterError,
  uppercaseLetterError,
  digitsError,
  specialCharError,
  notViewHelperText,
  ...props
}: RegisterPasswordTextFieldType): React.JSX.Element {
  const { t } = useTranslation();
  const isSuccess = !props.value ? "common.black" : "success.main";
  const helperText: React.ReactNode =
    props.error && !props.value ? (
      t("password.required")
    ) : (
      <>
        <Typography
          color={
            minMaxError ||
            lowercaseLetterError ||
            uppercaseLetterError ||
            digitsError ||
            specialCharError
              ? "error.main"
              : isSuccess
          }
          component="div"
          variant="caption"
        >
          {t("password.requirements")}
        </Typography>
        <Box component="ul" sx={{ m: "unset" }}>
          <Typography
            color={minMaxError ? "error.main" : isSuccess}
            component="li"
            variant="caption"
          >
            {t("password.minMax")}
          </Typography>
          <Typography
            color={uppercaseLetterError ? "error.main" : isSuccess}
            component="li"
            variant="caption"
          >
            {t("password.uppercase")}
          </Typography>
          <Typography
            color={lowercaseLetterError ? "error.main" : isSuccess}
            component="li"
            variant="caption"
          >
            {t("password.lowercase")}
          </Typography>
          <Typography
            color={digitsError ? "error.main" : isSuccess}
            component="li"
            variant="caption"
          >
            {t("password.digits")}
          </Typography>
          <Typography
            color={specialCharError ? "error.main" : isSuccess}
            component="li"
            variant="caption"
          >
            {t("password.special")}
          </Typography>
        </Box>
      </>
    );

  return (
    <HidenTextField
      {...props}
      helperText={notViewHelperText ? undefined : helperText}
      variant="outlined"
    />
  );
}
